import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import { DEFAULT_DATE_FORMAT, REQUIRED_TEXT, SSN_INVALID_TEXT, SSN_MASK_WITH_DASHES } from '@/common/constants';
import { Dependent } from '@/modules/employee/employee.types';
import { DEPENDENT_SSN_SECURE_MASK, isValidDependentSsn } from '@/modules/employee/Employee/Dependents/dependents.utils';
import { Relationship } from '@/modules/transaction/transaction.types';

interface Params {
  data?: Dependent;
  createMode: boolean;
  relationshipList: Relationship[]
}

export const useCardDependentForm = (params: Params) => useMemo((): Field[] => [
  {
    name: 'firstName',
    type: FieldTypes.Text,
    label: 'First name',
    placeholder: 'First name',
    validator: yup.string().required(REQUIRED_TEXT),
    defaultValue: params.data?.firstName || '',
    value: params.data?.firstName || '',
  },
  {
    name: 'lastName',
    type: FieldTypes.Text,
    label: 'Last name',
    placeholder: 'Last name',
    validator: yup.string().required(REQUIRED_TEXT),
    defaultValue: params.data?.lastName || '',
    value: params.data?.lastName || '',
  },
  ...(params.createMode ? [
    // {
    //   name: 'email',
    //   type: FieldTypes.Text,
    //   label: 'Email',
    //   placeholder: 'Email',
    //   validator: yup.string().required(REQUIRED_TEXT).email('Email must be valid.'),
    //   defaultValue: params.data?.email,
    // },
    {
      name: 'birthOn',
      type: FieldTypes.Date,
      isManualDateInput: true,
      label: 'Date of birth',
      placeholder: 'Select birth date',
      validator: VALIDATORS.DATE_FORMAT_MAX_TODAY.required(REQUIRED_TEXT),
      defaultValue: params.data?.birthOn || '',
      value: params.data?.birthOn || '',
      maxDate: dayjs(dayjs().add(0, 'day')),
    },
    {
      name: 'ssn',
      type: FieldTypes.Mask,
      label: 'SSN',
      placeholder: 'Enter SSN',
      mask: SSN_MASK_WITH_DASHES,
      secure: true,
      secureMask: DEPENDENT_SSN_SECURE_MASK,
      formatChars: { '*': /[*]/ },
      clearOnFocus: true,
      validator: yup.string().test('ssn', SSN_INVALID_TEXT, isValidDependentSsn),
      defaultValue: params.data?.ssn || '',
      value: params.data?.ssn || '',
    },
  ] as Field[] : [
    {
      name: 'birthOn',
      type: FieldTypes.Text,
      label: 'Date of birth',
      defaultValue: `
      ${dayjs(params.data?.birthOn).format(DEFAULT_DATE_FORMAT)}
       (${dayjs(params.data?.birthOn).toNow(true)})
       ` || '',
      value: `
      ${dayjs(params.data?.birthOn).format(DEFAULT_DATE_FORMAT)}
       (${dayjs(params.data?.birthOn).toNow(true)})
       ` || '',
    },
  ] as Field[]),
  {
    name: 'relationshipType',
    type: FieldTypes.Dropdown,
    label: 'Relationship',
    singleMode: true,
    placeholder: 'Select relationship',
    validator: yup.string().required(REQUIRED_TEXT),
    defaultValue: params.data?.relationshipType || '',
    value: params.data?.relationshipType || '',
    options: params.relationshipList.map((relationship) => ({
      key: `${relationship.value}`,
      value: `${relationship.value}`,
      title: `${relationship.name.charAt(0).toUpperCase()}${relationship.name.slice(1).toLowerCase()}`,
    })),
  },
], [params]);
